/**
 * [S6, polecenie właściciela 2026-09-13] HISTORIA WYSZUKIWANIA — „z historią w oknie modal ostatnio
 * wyszukiwanych pozycji".
 *
 * Pamięć per przeglądarka (localStorage), bez kontraktu API: ostatnie frazy to preferencja stanowiska,
 * nie dane firmy. Każdy odczyt i zapis w try/catch — localStorage potrafi rzucić (tryb prywatny, blokada
 * danych witryny) i wtedy okno po prostu startuje bez historii.
 */
export const KLUCZ_HISTORII = "mp:wyszukiwarka:historia";
export const MAKS_HISTORII = 8;

const odczytaj = () => {
    try {
        const surowe = window.localStorage.getItem(KLUCZ_HISTORII);
        const lista = surowe ? JSON.parse(surowe) : [];
        return Array.isArray(lista) ? lista.filter((x) => typeof x === "string" && x.trim()) : [];
    } catch {
        return [];
    }
};

const zapisz = (lista) => {
    try {
        window.localStorage.setItem(KLUCZ_HISTORII, JSON.stringify(lista.slice(0, MAKS_HISTORII)));
    } catch {
        /* brak pamięci = brak historii, nie awaria */
    }
};

export const wczytajHistorie = () => odczytaj();

/** Dopisuje frazę na początek (bez duplikatów, bez rozróżniania wielkości liter); zwraca nową listę. */
export const zapiszWHistorii = (fraza) => {
    const f = (fraza || "").trim();
    if (f.length < 2) return odczytaj();
    const bez = odczytaj().filter((x) => x.toLowerCase() !== f.toLowerCase());
    const nowa = [f, ...bez].slice(0, MAKS_HISTORII);
    zapisz(nowa);
    return nowa;
};

export const usunZHistorii = (fraza) => {
    const nowa = odczytaj().filter((x) => x.toLowerCase() !== (fraza || "").toLowerCase());
    zapisz(nowa);
    return nowa;
};

export const wyczyscHistorie = () => {
    zapisz([]);
    return [];
};
